<!-- <app-card [isHeader]=true [title]="titre_ajout_cons|translate">

    <mat-card-content>
        <mat-vertical-stepper class="mat-elevation-z0" [linear]="true">
            <mat-step [stepControl]="step1.form">
                <ng-template matStepLabel>{{
                    "Informations Sur Utilisateur"  | translate
                    }}</ng-template>
                <app-add-infog-certif (add)="onAdd()" #step1></app-add-infog-certif>

            </mat-step>
            <mat-step [stepControl]="step2.form">

                <ng-template matStepLabel>{{
                    "Attribution De(s) Droit(s) Administrateur Fournisseur
                    " | translate
                    }}</ng-template>

                <app-add-attribution-droit #step2 (add)="onAdd()">
                </app-add-attribution-droit>

            </mat-step>
            <mat-step [stepControl]="step3.form">
                <ng-template matStepLabel>{{
                    "Informations par lot ou article" | translate
                    }}</ng-template>

                <app-add-attribution-droit (add)="onAdd()" #step3></app-add-attribution-droit>
                <div style="padding-top:2.5% " fxLayoutAlign="end end">

                    <button
                            (click)="submit(step1.form.getRawValue(),

                        step2.form.getRawValue(),step3.tableForm.value)" color="primary" mat-raised-button>
                        <span translate>submit_save</span>
                    </button>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </mat-card-content>
</app-card> -->
<!-- <mat-card  appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
    <mat-card-header class="titree">
        {{ "Informations Sur Utilisateur
        " | translate }}
    </mat-card-header>
    <br>
    <mat-card-content class="card-content">
      <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
        -->
<app-add-infog-certif #add></app-add-infog-certif>
<!-- </div>
    </mat-card-content>
</mat-card> -->
